import { useEffect } from "react";

const FluxRedirect = () => {
  useEffect(() => {
    window.history.replaceState(null, "", "/flux/index.html");
    window.location.href = "/flux/index.html";
  }, []);

  return null; // or a loading indicator if you prefer
};

export default FluxRedirect;
